import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.mfa_required || data.totp_setup_required) {
      const err = new Error("SUPER_ADMIN_MFA");
      err.superMfa = true;
      throw err;
    }
    if (data.user?.role === "asistencia") {
      const err = new Error("ASISTENCIA_ACCOUNT");
      err.asistenciaAccount = true;
      throw err;
    }
    if (!data.token) {
      throw new Error("No se recibió token de sesión");
    }
    localStorage.setItem("token", data.token);
    const { data: me } = await api.get("/auth/me");
    setUser(me);
    return me;
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(false);
  };

  const refreshUser = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setUser(false);
      return null;
    }
    try {
      const { data: me } = await api.get("/auth/me");
      setUser(me);
      return me;
    } catch {
      localStorage.removeItem("token");
      setUser(false);
      return null;
    }
  };

  return (
    <AuthCtx.Provider value={{ user, ready, login, logout, refreshUser }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
